module.exports = {"460204198":"天涯镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460204.json
// module id = 2190
// module chunks = 0